<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="countries"
                    v-model="selectedCountry"
                    :label="i18n.country"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    :disabled="!user.hq"
                    dense
                    :loading="loading"
                    clearable
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-select
                    :items="years"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    :class="`${arabic?'arFont':'enFont'}`"
                    v-model="selectedYear"
                    label="Year"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-btn block text color="success" :loading="loading"
                    :class="`${arabic?'arFont':'enFont'}`" @click="loadResource()"
                  >
                    <v-icon left>sync</v-icon>
                    load
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC v-if="false">
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <v-col cols="12" v-for="(result, rr) in Object.values(data)" :key="'result'+rr">
                  <span :class="`${arabic?'arFont':'enFont'}`"
                    style="font-weight:700;"
                  >{{result}}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import candidateListPanel from '@/components/candidateListPanel'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
let api_fire_base = 'https://us-central1-aramcco-crm.cloudfunctions.net/main'

export default {
  components: { Search, Paging, multiDialog, candidateListPanel },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:false,
      },
      newResource:{},
      editing:false,
      deleting:false,
      countries:[],
      years:[2021, 2022, 2023, 2024],
      selectedCountry:null,
      selectedYear:null,
      data:[],
    }
  },
  
  methods: {
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x=>{
              return {
                ...x,
                text:x.name?x.name:x.en?x.en:'unknown',
                [`${f.name}_id`]:x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:`/weekly_count/${this.selectedCountry?this.selectedCountry:1}/${this.selectedYear?this.selectedYear:2022}`})
          this.countries = this.resource.countries
          this.data = this.resource.data
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:`/weekly_count/${this.selectedCountry?this.selectedCountry:1}/${this.selectedYear?this.selectedYear:2022}`})
          this.countries = this.resource.countries
          this.data = this.resource.data
        }
        this.loading = false
        await this.loadItems()
        res(true)
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
        res(true)
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
        res(true)
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async registerToFire(candidate){
      return new Promise(async (res, rej)=>{
        let user = {
          name:candidate.name,
          email:candidate.email,
          password: randomString(8, '#Aa')
        }
        let a = await axios.post(`${api_fire_base}/registerNewUser`, user, {headers:headers}).then(x=>x.data)
        .catch(error => console.log(error))
        res({...user, ...a.user})
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let user = await this.registerToFire(r)
        r.generated_password = user.password
        r.google_uid = user.uid
        console.log(user.uid)
        this.generated_user = user
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>